import { render, staticRenderFns } from "./renew-modal.vue?vue&type=template&id=60ca8920&"
import script from "./renew-modal.vue?vue&type=script&lang=js&"
export * from "./renew-modal.vue?vue&type=script&lang=js&"
import style0 from "./renew-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports